import ViewStore from "../../ViewStore";
import AppContainer from "../../AppContainer";
import ActionsLocator from "../ActionsLocator";
import UserPreferencesStore from "../../UserPreferencesStore";
import  { OfferPanelPageProps } from "../../../view/page/offer-panel/OfferPanelPage";
import { MediumsListProps } from "../../../view/page/offer-panel/offer-creator/mediums-list/MediumsList";

export default class ViewPropsFactory {
    private appContainer: AppContainer;
    private store: ViewStore;
    private userPreferencesStore: UserPreferencesStore;
    private actionsLocator: ActionsLocator;

    constructor(appContainer: AppContainer) {
        this.appContainer = appContainer;
        this.store = appContainer.getViewStore();
        this.userPreferencesStore = appContainer.getUserPreferencesStore();
        this.actionsLocator = appContainer.getActionsLocator();
    }

    public offerPanel = (): OfferPanelPageProps => ({
        copyTextToClipboard: this.actionsLocator.copyTextToClipboard,
        getOffer: this.actionsLocator.getOffer(),
        mediumsListProps: this.mediumsList(),
        offerUrlFactory: this.appContainer.getOfferUrlFactory(),
        getOfferMediums: this.actionsLocator.getOfferMediums(),
        photoUrlFactory: this.appContainer.getPhotoUrlFactory(),
        updateOffer: this.actionsLocator.updateOffer(),

    })
    public mediumsList = (): MediumsListProps => ({
        copyTextToClipboard: this.actionsLocator.copyTextToClipboard(),
        getMediumFilterOptions: this.actionsLocator.getMediumFilterOptions(),
        photoUrlFactory: this.appContainer.getPhotoUrlFactory(),
        getOfferMediums: this.actionsLocator.getOfferMediums(),
        updateManyAvailabilities: this.actionsLocator.updateManyAvailabilities(),
        getAllMediumIds: this.actionsLocator.getAllMediumIds(),
    });
}